import script from "./VideoConferenceActions.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoConferenceActions.vue?vue&type=script&setup=true&lang=js"

import "./VideoConferenceActions.vue?vue&type=style&index=0&id=3766c46d&lang=scss"

const __exports__ = script;

export default __exports__